// Where the kits-delivered hand-off stands, and "Sync now" for whoever may, as
// MIST.Web's SyncNow shows a hand-off: the button over "Source · Last synced
// 10:42 · updates on its own". A kits-delivered message runs the same sync
// (ADR-0077), so there is no next run to predict; the button is for not waiting.
import { useSyncKits, useSyncStatus } from '../../api/queries';
import { Button, ErrorPanel } from '../../design/components';

const SOURCE = 'Kits delivered by Manufacturing';
const time = new Intl.DateTimeFormat(undefined, { timeStyle: 'short' });

export function SyncLine({ canAct }: { canAct: boolean }) {
    const status = useSyncStatus();
    const sync = useSyncKits();
    const last = status.data?.lastSyncedAt;
    return (
        <div className="sf-sync sf-no-print">
            {canAct ? (
                // Starts with the visible text, so a voice user can say what they see (WCAG 2.5.3).
                <Button
                    aria-label={`${sync.isPending ? 'Syncing…' : 'Sync now'}: ${SOURCE}`}
                    disabled={sync.isPending}
                    onClick={() => {
                        sync.mutate();
                    }}
                >
                    {sync.isPending ? 'Syncing…' : 'Sync now'}
                </Button>
            ) : null}
            <span className="text-sm sf-sync-status">
                {SOURCE} · {last ? `Last synced ${time.format(new Date(last))}` : 'Not synced yet'}
                {' · updates on its own'}
            </span>
            {sync.isSuccess ? (
                <span className="text-sm sf-sync-status" role="status">
                    {sync.data.buildsQueued} new build(s), {sync.data.skipped} already queued
                </span>
            ) : null}
            {sync.isError ? <ErrorPanel error={sync.error} /> : null}
        </div>
    );
}
